import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import logo from "../assets/logo.png";
import { Divider, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuIcon from "@mui/icons-material/Menu";
import QuoteDialog from "./QuoteDialog";

const navLink = [
  { name: "home", path: "/", hasDropdown: false },
  { name: "services", path: "/services", hasDropdown: true },
  { name: "about", path: "/about", hasDropdown: false },
  { name: "blog", path: "/blog", hasDropdown: false },

  { name: "contact", path: "/contact", hasDropdown: false },
];
const socialLinks = [
  { icon: <FacebookIcon />, link: "https://www.facebook.com" },
  { icon: <TwitterIcon />, link: "https://www.x.com" },
  { icon: <InstagramIcon />, link: "https://www.instagram.com" },
];

const Navbar = () => {
  const location = useLocation();
  useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo(0, 0);
    };
    handleRouteChange();
  }, [location]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [showMobileNav, setShowMobileNav] = useState(false);

  const [isFixed, setIsFixed] = useState(false);

  const ref = useRef();
  const ref2 = useRef();
  const handleScroll = () => {
    const scrollY = window.scrollY;
    const targetDivHeight =
      ref.current?.clientHeight + ref2.current?.clientHeight;

    if (scrollY >= targetDivHeight) {
      if (!isFixed) {
        setTimeout(() => {
          setIsFixed(true);
        }, 300);
      }
    } else {
      setIsFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isFixed]);
  const [dialogState, setDialogState] = useState(false);
  const toggleDialog = (e) => {
    setDialogState((prev) => !prev);
  };
  const handleKeyClose = (e) => {
    if (e.key === "Escape") {
      setDialogState(false);
      document.body.style.overflow = "auto";
    }
  };
  return (
    <header className="" onKeyDown={(e) => handleKeyClose(e)}>
      <QuoteDialog state={dialogState} toggle={toggleDialog} />
      <div ref={ref} className="bg-primary w-full">
        <div className=" max-screen px-2 sm:px-4   py-3 flex flex-col md:flex-row justify-between items-center gap-2">
          <ul className="flex  text-white items-center gap-4 flex-wrap justify-center text-sm md:text-base">
            <li className="flex items-center gap-1 hover:underline  underline-offset-4">
              <PhoneIcon />
              <a className="text-white " href="tel:9412884338">
                (941) 288-4338
              </a>
            </li>
            <li className="flex items-center gap-1 hover:underline  underline-offset-4">
              <MailIcon />
              <a className="" href="mailto:landscapingservicesal@gmail.com">
                landscapingservicesal@gmail.com
              </a>
            </li>
            <li className=" items-center gap-1 hidden sm:flex">
              <WatchLaterIcon />
              <span className="">Mon-Fri, 8:30am - 6.30pm </span>
            </li>
          </ul>

          <ul className="flex gap-3">
            {socialLinks.map((item, index) => {
              return (
                <div
                  key={index}
                  className="w-8 h-8 text-white  hover:bg-white hover:text-primary rounded-full flex-c transition-all">
                  <a key={index} href={item.link}>
                    {item.icon}
                  </a>
                </div>
              );
            })}
          </ul>
        </div>
      </div>

      {/* nav desktop */}
      <nav
        ref={ref2}
        className={`hidden lg:block bg-white text-neutral-2 py-4 border-b ${
          isFixed ? "fixed nav-animation top-0" : "relative top-auto"
        }  left-0 w-full  z-[999] `}>
        <div className="max-screen flex justify-between gap-4">
          <Link to={"/"} className="flex items-center gap-0">
            <img
              src={logo}
              alt="logo"
              width={128}
              className="hover:brightness-105 transition-all"
            />
          </Link>
          <div className="flex items-center gap-4">
            <ul className="flex items-center gap-4 xl:gap-8 capitalize text-neutral-2  xl:text-lg font-semibold">
              {navLink.map((item, index) => {
                return item.hasDropdown ? (
                  <button
                    key={index}
                    to={item.path}
                    className={`flex items-end capitalize gap-0 ${
                      open && "text-secondary"
                    }`}
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}>
                    {item.name}
                    <ArrowDropDownIcon />
                  </button>
                ) : (
                  <Link
                    key={index}
                    to={item.path}
                    className="hover:text-secondary">
                    {item.name}
                  </Link>
                );
              })}
            </ul>
            <ServicesMenu
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
            />
            <Divider sx={{ transform: "rotate(90deg)", width: "20px" }} />
            <button onClick={() => toggleDialog()} className="btn btn-main">
              Get a Quote
            </button>
          </div>
        </div>
      </nav>

      {/* nav mobile */}
      <nav
        className={`block lg:hidden bg-white text-neutral-2 py-4  ${
          isFixed ? "fixed nav-animation top-0" : "relative top-auto"
        }  left-0 w-full  z-[999]`}>
        <div className="max-screen flex justify-between gap-4">
          <Link to={"/"} className="flex items-center gap-0">
            <img src={logo} alt="logo" width={96} className="w-24 sm:w-32" />
          </Link>
          <div className="flex items-center gap-1 sm:gap-4">
            <ServicesMenu
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
            />

            <button
              onClick={() => toggleDialog()}
              className="btn btn-main text-sm sm:text-base">
              Get a Quote
            </button>
            <Divider sx={{ transform: "rotate(90deg)", width: "20px" }} />
            <button onClick={() => setShowMobileNav((prev) => !prev)}>
              <MenuIcon />
            </button>
          </div>
        </div>
        <MobileNavDropdown
          open={open}
          handleClick={handleClick}
          showMobileNav={showMobileNav}
        />
      </nav>
    </header>
  );
};
export default Navbar;

const ServicesMenu = ({ anchorEl, open, handleClose }) => {
  return (
    <Menu
      id="services"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "services",
      }}>
      <MenuItem onClick={handleClose}>
        <Link to="/services/landscaping" className="p-2">
          Landscaping
        </Link>
      </MenuItem>
      <MenuItem onClick={handleClose} className="p-2">
        <Link to="/services/lawn-care" className="p-2">
          Lawn Care
        </Link>
      </MenuItem>
      <MenuItem onClick={handleClose} className="p-2">
        <Link to="/services/tree" className="p-2">
          Tree Services
        </Link>
      </MenuItem>
      <MenuItem onClick={handleClose} className="p-2">
        <Link to="/services/irrigation" className="p-2">
          Irrigation
        </Link>
      </MenuItem>
    </Menu>
  );
};

const MobileNavDropdown = ({ open, handleClick, showMobileNav }) => {
  return (
    <div
      className={` w-full z-[999] bg-white animate-slide-in shadow-xl   py-8 px-4 border-t-2 border-primary  absolute top-[100px] sm:top-32 ${
        showMobileNav ? "block " : "hidden"
      }`}>
      {" "}
      <ul className="flex flex-col items-start gap-4 xl:gap-8 capitalize text-neutral-2  xl:text-lg font-semibold">
        {navLink.map((item, index) => {
          return item.hasDropdown ? (
            <button
              key={index}
              to={item.path}
              className={`flex items-end capitalize gap-0 ${
                open && "text-secondary"
              }`}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}>
              {item.name}
              <ArrowDropDownIcon />
            </button>
          ) : (
            <Link key={index} to={item.path} className="hover:text-secondary">
              {item.name}
            </Link>
          );
        })}
        <li className="w-full flex items-center justify-center gap-1  sm:hidden">
          <WatchLaterIcon />
          <span className="">Mon-Fri, 8:30am - 6.30pm </span>
        </li>
      </ul>
    </div>
  );
};
